import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { isLight, darken, lighten } from 'library/util/css';
import ColorContext, { DefaultColors } from 'context/color';
import withColor from 'util/hoc/with-color';

export const NoStyleButton = styled.button`
  background: unset;
  border: unset;
  color: inherit;
  text-align: unset;
  font-size: unset;
  padding: unset;
  font-family: unset;
  border-radius: unset;
  text-transform: unset;
  font-weight: unset;

  :not(:disabled):hover {
    background: unset;
    border-color: unset;
  }

  :not(:disabled):focus {
    outline: solid 2px highlight;
  }
`;

export const BaseButtonStyle = css`
  display: inline-block;
  padding: 1em 2em;
  -webkit-appearance: none;
  text-decoration: none;
  border: 2px solid ${(props) => props.color};
  border-radius: 0.25em;
  background: ${(props) => props.color};
  font-weight: bold;
  text-transform: uppercase;
  color: ${(props) =>
    isLight(props.color, 200) ? darken(props.color, 0.5) : '#fff'};
  outline: none;
  cursor: pointer;
  font-size: 0.7em;
  font-family: Lato;
  display: flex;
  align-items: center;
  :not(:disabled):hover {
    background: ${(props) => darken(props.color, 0.2)};
    border-color: ${(props) => darken(props.color, 0.2)};
    color: ${(props) =>
      isLight(darken(props.color, 0.2), 200)
        ? darken(props.color, 0.5)
        : '#fff'};
  }
  :disabled {
    background: ${(props) => lighten(props.color, 0.4)};
    border-color: ${(props) => lighten(props.color, 0.4)};
    cursor: not-allowed;
  }
  width: ${(props) => props.width};
  ${(props) => props.height && `height: ${props.height};`}

  + button {
    margin: 0;
  }
`;

export const BaseOutlineButton = withColor(styled.button`
  display: flex;
  padding: 0em 0.75em;
  align-items: center;
  background: unset;
  border-width: 1px;
  color: ${(props) => props.theme.colors.blue400};
  border-color: ${(props) => props.theme.colors.grey300};
  text-transform: capitalize;
  height: 30px;
  font-size: 0.9em;
  font-weight: 600;
  transition: all 0.2s ease-in-out;

  &&&:hover,
  :focus {
    background: unset;
    border-color: ${(props) => props.theme.colors.blue400};
  }
`);

BaseButtonStyle.propTypes = {
  color: PropTypes.string,
};

BaseButtonStyle.defaultProps = {
  color: DefaultColors.primary,
};

export const BaseButton = styled.button`
  ${BaseButtonStyle}
`;
BaseButton.propTypes = {
  color: PropTypes.string,
  fontColor: PropTypes.string,
};

BaseButton.defaultProps = {
  color: DefaultColors.primary,
  fontColor: DefaultColors.grey1,
};

export const Button = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton fontColor={colors.grey1} color={colors.primary} {...props} />
    )}
  </ColorContext.Consumer>
);
export const SecondaryButton = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey1}
        color={colors.secondary}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);
export const TertiaryButton = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton fontColor={colors.grey1} color={colors.tertiary} {...props} />
    )}
  </ColorContext.Consumer>
);

export const FullWidthButton = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <TertiaryButton
        fontColor={colors.grey1}
        color={colors.tertiary}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);

export const AuxilaryButton1 = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey1}
        color={colors.auxilary_1}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);
export const AuxilaryButton2 = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey1}
        color={colors.auxilary_2}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);

export const CancelButton = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey800}
        color={colors.grey300}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);
export const AuxilaryButton3 = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey1}
        color={colors.auxilary_3}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);
export const AuxilaryButton4 = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey1}
        color={colors.auxilary_4}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);
export const AuxilaryButton5 = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey1}
        color={colors.auxilary_5}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);
export const AuxilaryButton6 = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey1}
        color={colors.auxilary_6}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);
export const AuxilaryButton7 = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey1}
        color={colors.auxilary_7}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);
export const AuxilaryButton8 = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey1}
        color={colors.auxilary_8}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);
export const AuxilaryButton9 = (props) => (
  <ColorContext.Consumer>
    {(colors) => (
      <BaseButton
        fontColor={colors.grey1}
        color={colors.auxilary_9}
        {...props}
      />
    )}
  </ColorContext.Consumer>
);

export default Button;
